import { render, staticRenderFns } from "./OpenResourceDetail.vue?vue&type=template&id=226771bc&scoped=true"
import script from "./OpenResourceDetail.vue?vue&type=script&lang=js"
export * from "./OpenResourceDetail.vue?vue&type=script&lang=js"
import style0 from "./OpenResourceDetail.vue?vue&type=style&index=0&id=226771bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226771bc",
  null
  
)

export default component.exports